import PopUpAds from "@/modules/pop_up_ads/components/PopUpAds";
import PopUpAdsForm from "@/modules/pop_up_ads/components/PopUpAdsForm";

export default [
    {
        path: "/pop-up-ads",
        name: "PopUpAds",
        component: PopUpAds,
    },
    {
        path: "/pop-up-ads/form",
        name: "PopUpAdsForm",
        component: PopUpAdsForm,
    },
];



// WEBPACK FOOTER //
// ./src/modules/pop_up_ads/router/pop_up_ads.js